import { ReactElement } from 'react';

function PandoraAdXcelPixel(): ReactElement {
  return (
    <img
      src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action=registration&pixid=ADXCEL_PIXEL_ID"
      alt=""
      style={{
        width: '1px',
        height: '1px',
        border: 'none',
      }}
    />
  );
}

export default PandoraAdXcelPixel;
